// Design tokens for each selectable site template. The slug is the shared
// contract with the backend (App\Support\SiteTemplates). Values are
// space-separated RGB channels to match the Tailwind `rgb(var(--x) / <a>)`
// setup in index.css / tailwind.config.js.
//
// Colours are only half of the story: each slug also activates a full design
// system (typography, radii, shadows, gradients, component skins) defined in
// themes.css under the matching [data-theme="slug"] selector.
//
// The "classic" default (templates disabled) is intentionally NOT listed here:
// it is simply the :root defaults in index.css, i.e. the original design with
// no changes.

export const THEME_TOKENS = {
  // "الأنيق" — the polished, professional evolution of the original identity.
  // Deep violet + coral, soft layered depth, Alexandria applied properly.
  refined: {
    "--c-purple": "59 42 82", // #3B2A52
    "--c-purple-light": "138 92 208", // #8A5CD0
    "--c-orange": "240 84 60", // #F0543C
    "--c-bage": "255 158 138", // #FF9E8A
    "--c-silver": "240 237 250", // #F0EDFA
    "--c-app-start": "232 221 250", // #E8DDFA
  },
  // "الملكي" — luxury editorial. Indigo ink + champagne gold on ivory paper,
  // El Messiri display type, hairline gold borders, stately small radii.
  royal: {
    "--c-purple": "30 35 87", // #1E2357
    "--c-purple-light": "86 95 168", // #565FA8
    "--c-orange": "176 138 61", // #B08A3D champagne gold
    "--c-bage": "226 200 141", // #E2C88D
    "--c-silver": "240 238 229", // #F0EEE5 ivory
    "--c-app-start": "235 232 220", // #EBE8DC
  },
  // "الزمردي" — modern minimal. Deep forest green + amber on near-white,
  // IBM Plex Sans Arabic, flat surfaces, hairline borders, micro shadows.
  emerald: {
    "--c-purple": "16 77 62", // #104D3E
    "--c-purple-light": "32 128 100", // #208064
    "--c-orange": "196 130 14", // #C4820E amber
    "--c-bage": "240 205 130", // #F0CD82
    "--c-silver": "230 240 235", // #E6F0EB
    "--c-app-start": "222 236 229", // #DEECE5
  },
  // "اليوم الوطني" — Saudi National Day 96 celebration. National green +
  // pure white + festive gold accents, Noto Kufi Arabic display type,
  // animated confetti, celebratory motion.
  national_day: {
    "--c-purple": "0 108 53", // #006C35 Saudi green
    "--c-purple-light": "0 165 79", // #00A54F bright green
    "--c-orange": "200 162 61", // #C8A23D festive gold
    "--c-bage": "230 210 140", // #E6D28C light gold
    "--c-silver": "232 244 236", // #E8F4EC mint mist
    "--c-app-start": "220 240 228", // #DCF0E4 soft green wash
  },
  // "الغروب" — warm & expressive. Plum + coral + amber, rounded Baloo
  // Bhaijaan type, pill buttons, big radii, soft warm glows.
  sunset: {
    "--c-purple": "94 33 66", // #5E2142
    "--c-purple-light": "178 84 122", // #B2547A
    "--c-orange": "244 92 42", // #F45C2A coral
    "--c-bage": "255 178 102", // #FFB266 amber
    "--c-silver": "250 233 235", // #FAE9EB
    "--c-app-start": "250 221 205", // #FADDCD
  },
};

export const THEME_VARS = [
  "--c-purple",
  "--c-purple-light",
  "--c-orange",
  "--c-bage",
  "--c-silver",
  "--c-app-start",
];
